<footer class="pt-5 pb-4 border-top">

          <!-- <div class="footer-social p-3">
            <div class="container border-bottom ">
                    <div class="col-12 d-block py-3 ">
                        <div class="d-flex align-items-center gap-2 justify-content-center">
                         {{'Follow Us' | translate | async}}

                        </div>
                    </div>
                </div>
            </div> -->
            <div class="footer-top">
                <div class="container">
                    <div class="row g-3 align-items-start">
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3 footer-logo">
                            <div >
                                <div class="d-flex align-items-center gap-3 w-100 my-2 footer-logo">
                                    <a routerLink=""><img src="../../../../assets/images/logo/Mahasarthi.png" class="max-w-160-px" alt="MahaSarathi"  /></a>
                                    <!-- <p class="m-0"><small>{{"Maha" | translate | async }}<span class="text-red">{{ 'Sarathi' | translate | async }}</span></small></p> -->
                                </div>
                                <div class="col-12 d-block pt-4 social-icons">
                                    {{'Follow Us' | translate | async}}
                                    <div class="d-flex align-items-center gap-2 justify-content-start pt-3">
                                        <ng-container *ngFor="let i of socialicon">
                                            <a routerLink=""><img src="assets/images/social/{{i.icon}}"  loading="lazy" class="w-24-px h-24-px"  alt="name" /></a>
                                        </ng-container>
                                    </div>
                                </div>

                                <!-- <div class="d-flex w-100 copy-rights">
                                        <p class="m-0"><small>{{"MahaSarathi" | translate | async}}</small></p>
                                </div> -->
                                 <!-- <ul class="mt-4">
                                    <li><a routerLink="">{{"Facebook" | translate | async}}</a></li>
                                    <li><a routerLink="">{{"Instagram" | translate | async}}</a></li>
                                    <li><a routerLink="">{{"Twitter" | translate | async}}</a></li>
                                </ul> -->
                            </div>
                        </div>
                        <!-- <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div class="row p-1 justify-content-center justify-content-md-end"> -->
                                <!-- <div class="col-12 text-center">
                                    <div class="footer-title">{{"Download MahaSarathi Mobile App" | translate | async}}</div>
                                </div> -->
                                <!-- <div class="col-4">
                                    <div class="h-100 d-flex flex-column align-items-center justify-content-end">
                                        <qrcode [qrdata]="'https://www.gogole.com/'" [width]="80" [errorCorrectionLevel]="'M'" class="d-block" title="{{'Coming Soon...'| translate | async}}"></qrcode>
                                        <a routerLink="" target="_blank" class="mt-2"><img src="assets/images/svg/google.svg" loading="lazy" alt="GOOGLE" title="{{'Coming Soon...'| translate | async}}" class=" img-fluid w-100 w-135-px h-40-px"></a>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="h-100 d-flex flex-column align-items-center justify-content-end">
                                        <qrcode [qrdata]="'https://www.apple.com/'" [width]="80" [errorCorrectionLevel]="'M'" class="d-block"  title="{{'Coming Soon...'| translate | async}}"></qrcode>
                                        <a routerLink="" target="_blank" class="mt-2"><img src="assets/images/svg/ios.svg" loading="lazy" alt="IOS" title="{{'Coming Soon...'| translate | async}}" class=" img-fluid w-100 w-135-px h-40-px"></a>
                                    </div>
                                </div> -->

                            <!-- </div>
                        </div> -->
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <!-- <div class="col-12">
                                <div class="footer-title">{{"Quick Links" | translate | async}}</div>
                            </div> -->
                            <!-- <div class="d-flex flex-column">
                                <div class="row gallery-box mb-3">
                                    <div class="col-12 d-flex justify-content-center mx-auto mb-1 flex-wrap gap-2 px-0">
                                        <ng-container *ngFor="let slide of slidesStore;">
                                            <a [href]="slide.url" (click)="openRedirectModal(slide.alt)" tabindex="-1">
                                                <img class="fadel" [src]="slide.src" loading="lazy" [alt]="slide.alt" [title]="slide.title"
                                                    class="img-fluid  h-45-px bg-white mx-auto d-block border rounded-2" width="80" height="40" style="aspect-ratio: 4/2 auto">
                                            </a>
                                        </ng-container>
                                    </div>
                                </div> -->
                                <div class="footer-logo d-flex align-items-center">
                                    <span class="fw-bold text-pink">{{ 'Quick Links' | translate | async }}</span>
                                </div>
                                <ul class="mt-4">
                                    <li><a class="mb-2 text-decoration-none " routerLink="/home/landing">{{"Home" | translate | async}}</a></li>
                                    <li><a class="mb-2 text-decoration-none " routerLink="/home/about-mh-ucdh">{{"About Us" | translate | async}}</a></li>
                                    <li><a class="mb-2 text-decoration-none " routerLink="/home/gallery" [queryParams]="{tab: 'photo'}">{{"Photo Gallery" | translate | async}}</a></li>
                                    <li><a class="mb-2 text-decoration-none " routerLink="/home/gallery" [queryParams]="{tab: 'video'}">{{"Video Gallery" | translate | async}}</a></li>
                                    <li><a class="mb-2 text-decoration-none " routerLink="/home/user-manual">{{"Help" | translate | async}}</a></li>
                                </ul>
                            </div>

                            <!-- <div class="col-12">
                                <div class="footer-title">{{"Useful Links" | translate | async}}</div>
                            </div> -->
                            <!-- <div class="d-flex align-items-center justify-content-center">
                                <div class="d-flex align-items-center justify-content-center">
                                    <ul class="d-flex justify-content-center align-items-center p-0 d-inline flex-wrap">
                                        <li></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/disclaimer-and-policies">{{disclaimerTitle}}</a></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/user-manual">{{"FAQs" | translate | async}}</a></li>
                                        <li></li>
                                        <li></li> -->
                                        <!-- <li><a class="mb-2 text-decoration-none " routerLink="/home/terms-conditions">{{"Terms and Conditions" | translate | async}}</a></li> -->
                                        <!-- <li><a class="mb-2 text-decoration-none " routerLink="/home/terms-and-conditions">{{termsAndConditionsTitle}}</a></li> -->
                                    <!-- </ul>
                                    <ul class="d-flex flex-column p-0"> -->


                                        <!-- <li><a class="mb-2 text-decoration-none " routerLink="/home/disclaimer-policies">{{"Disclaimer and Policies" | translate | async}}</a></li> -->

                                    <!-- </ul>
                                </div>
                            </div>
                            <div class="col-12 d-block py-1">
                                <div class="d-flex align-items-center gap-2 justify-content-center">
                                     {{'Follow Us' | translate | async}} -->
                                    <!-- <ng-container *ngFor="let i of socialicon">
                                        <a routerLink=""><img src="assets/images/social/{{i.icon}}"  loading="lazy" class="w-24-px h-24-px"  alt="name" /></a>
                                    </ng-container>
                                </div>
                            </div> -->

                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div class="footer-logo d-flex align-items-center">
                                <span class="fw-bold text-pink"> {{ 'Other Links' | translate | async }}</span>
                            </div>
                            <ul class="mt-4">
                                <li><a class="mb-2 text-decoration-none " routerLink="/home/faqs">{{"Frequently Asked Questions" | translate | async}}</a></li>
                                <li><a class="mb-2 text-decoration-none " routerLink="/home/terms-and-conditions">{{"Terms and Conditions" | translate | async}}</a></li>
                                <li><a class="mb-2 text-decoration-none " routerLink="/home/disclaimer-and-policies">{{"Disclaimer and Policies" | translate | async}}</a></li>
                                <li><a class="mb-2 text-decoration-none " routerLink="/home/sitemap">{{"Sitemap" | translate | async}}</a></li>
                                <li><a class="mb-2 text-decoration-none " routerLink="/home/circulars">{{"Circulars" | translate | async}}</a></li>
                                <!-- <li><a class="mb-2 text-decoration-none " routerLink="">{{"Feedback" | translate | async}}</a></li> -->

                            </ul>
                            <!-- <div class="col-12">
                                <div class="footer-title">{{"Quick Links" | translate | async}}</div>
                            </div> -->
                            <!-- <div class="d-flex flex-column">
                                <div class="row gallery-box mb-3">
                                    <div class="col-12 d-flex justify-content-center mx-auto mb-1 flex-wrap gap-2 px-0">
                                        <ng-container *ngFor="let slide of slidesStore;">
                                            <a [href]="slide.url" (click)="openRedirectModal(slide.alt)" tabindex="-1">
                                                <img class="fadel" [src]="slide.src" loading="lazy" [alt]="slide.alt" [title]="slide.title"
                                                    class="img-fluid  h-45-px bg-white mx-auto d-block border rounded-2" width="80" height="40" style="aspect-ratio: 4/2 auto">
                                            </a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="col-12">
                                <div class="footer-title">{{"Useful Links" | translate | async}}</div>
                            </div> -->
                            <!-- <div class="d-flex align-items-center justify-content-center">
                                <div class="d-flex align-items-center justify-content-center">
                                    <ul class="d-flex justify-content-center align-items-center p-0 d-inline flex-wrap">
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/about-mh-ucdh">{{"About Us" | translate | async}}</a></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/disclaimer-and-policies">{{disclaimerTitle}}</a></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/user-manual">{{"FAQs" | translate | async}}</a></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/user-manual">{{"Help" | translate | async}}</a></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="home/sitemap">{{"Sitemap" | translate | async}}</a></li>
                                        <li><a class="mb-2 text-decoration-none " routerLink="/home/terms-conditions">{{"Terms and Conditions" | translate | async}}</a></li> -->
                                        <!-- <li><a class="mb-2 text-decoration-none " routerLink="/home/terms-and-conditions">{{termsAndConditionsTitle}}</a></li> -->
                                    <!-- </ul>
                                    <ul class="d-flex flex-column p-0"> -->


                                        <!-- <li><a class="mb-2 text-decoration-none " routerLink="/home/disclaimer-policies">{{"Disclaimer and Policies" | translate | async}}</a></li> -->

                                    <!-- </ul>
                                </div>
                            </div>
                            <div class="col-12 d-block py-1">
                                <div class="d-flex align-items-center gap-2 justify-content-center">
                                     {{'Follow Us' | translate | async}} -->
                                    <!-- <ng-container *ngFor="let i of socialicon">
                                        <a routerLink=""><img src="assets/images/social/{{i.icon}}"  loading="lazy" class="w-24-px h-24-px"  alt="name" /></a>
                                    </ng-container>
                                </div>
                            </div> -->
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <!-- <div class="footer-logo d-flex align-items-center mb-4">
                                <span class="fw-bold">{{ 'Play Store' | translate | async }}</span>
                            </div> -->
                            <div class="footer-logo d-flex align-items-center mb-4">
                                <span class="fw-bold text-pink"> {{ 'Download App' | translate | async }}</span>
                            </div>
                            <div class="play-store d-flex align-items-start flex-column gap-3">
                                <div class="google-play-store d-flex align-items-center gap-2 gap-sm-2 p-3 pink-light-bg rounded-3">
                                    <!-- <div class="scan-wrapper">
                                        <img src="../../../../assets/images/svg/google-scan.svg" alt="Google Scan" />
                                    </div> -->
                                    <!-- <qrcode [qrdata]="'https://mahasarathi.maharashtra.gov.in/home/landing'" [width]="55" [errorCorrectionLevel]="'M'" class="d-block" title="{{'Coming Soon...'| translate | async}}"></qrcode> -->
                                                                            <a href="https://mahasarathi.maharashtra.gov.in/home/landing" target="_blank">
  <img
    src="assets/images/png/mahasarathi_QR.png"
    width="55"
    class="d-block"
    title="{{ 'Coming Soon...' | translate | async }}"
  />
</a>
                                    <a href="javascripts:;" class="d-flex flex-column text-center text-pink" target="_self"><img src="assets/images/svg/google.svg" loading="lazy" alt="GOOGLE" class=" img-fluid w-100 w-135-px h-35-px">
                                        </a>
                                    <!-- <img src="../../../../assets/images/svg/google-app.svg" alt="Google App" /> -->
                                </div>
                                <div class="google-play-store d-flex align-items-center gap-2 gap-sm-2 p-3 pink-light-bg rounded-3">
                                    <!-- <div class="scan-wrapper">
                                        <img src="../../../../assets/images/svg/ios-scan.svg" alt="IOS Scan" />
                                    </div> -->
                                    <qrcode [qrdata]="'https://mahasarathi.maharashtra.gov.in/home/landing'" [width]="55" [errorCorrectionLevel]="'M'" class="d-block"  title="{{'Coming Soon...'| translate | async}}"></qrcode>
                                        <!-- <a routerLink="" target="_blank" ><img src="assets/images/svg/ios.svg" loading="lazy" alt="IOS" title="{{'Coming Soon...'| translate | async}}" class=" img-fluid w-100 w-135-px h-35-px"></a> -->
                                         <a href="javascripts:;" class="d-flex flex-column text-center text-pink" target="_self" ><img src="assets/images/svg/ios.svg" loading="lazy" alt="IOS" title="{{'Coming Soon...'| translate | async}}" class=" img-fluid w-100 w-135-px h-35-px">
                                        {{'Coming Soon...'| translate | async}}</a>
                                    <!-- <img src="../../../../assets/images/svg/ios-app.svg" alt="IOS App" /> -->
                                </div>
                            </div>
                        </div>


                        <div class="copy-right footer-bottom-wrapper d-flex align-items-center flex-wrap justify-content-between gap-2 px-0">
                            <p class="m-0 px-0">{{ 'Copyright © 2026 This website belongs to the State Government of Maharashtra.' | translate | async }} <br /> {{'Designed, Developed and Maintained by MahaIT' | translate | async }}</p>
                            <p class="d-flex align-items-center justify-content-end flex-wrap mb-0">
                                <span class="text-black-custom pe-4">{{ 'Visitors' | translate | async }}: <span class="text-pink">{{Visitorscount}}</span></span>
                                <span class="text-black-custom border-left ps-4">{{ 'Website Last updated on' | translate | async }}: <span class="text-pink">{{'27/10/2026' | translate | async }}</span></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

    <!-- <div class=" text-center w-100 footer-top">
        <div class="container position-relative">

        </div>
    </div> -->
</footer>

<!-- Confirmation Modal -->
<div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="revokeModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content bg-transparent">
            <div [class]="'modal-body bg-white' | themeSwitch">
                <div class="p-3 position-relative">
                    <p class="fw-bold text-center"> {{ "You are being redirected to an external website.Please note that
                        GR Citizen Portal website is not responsible for external website content & privacy policies." |
                        translate | async }} </p>
                    <div class="d-flex align-items-center justify-content-center">
                        <button class="btn btn-primary bg-orange-light  mx-1" (click)="openSlideInNewTab()">
                            {{ "Go to website" | translate | async }}
                        </button>
                        <button [class]="'btn btn-dark mx-1' | themeSwitch" (click)="confirmationModal.hide()">
                            {{ "Close" | translate | async }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

